import api from "../api";

const endpoint = "/api/dashboard";
const obterTodosAtendimentosNaoEncerradosPrimeiroContato = async (
  logins,
  dataInicial,
  dataFinal
) => {

  dataInicial = dataInicial.replaceAll("/", "%2F");
  dataFinal = dataFinal.replaceAll("/", "%2F");


  return new Promise((resolve, reject) => {
    return api
      .get(
        endpoint +
          `/nao-encerrados-no-primeiro-contato?${logins
            .map((login) => {
              return "logins=" + login;
            })
            .join("&")}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`
      )
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const obterTodosAtendimentosAbertosPorTerceirosEncerradosPorMim = async (
  logins,
  dataInicial,
  dataFinal
) => {

  dataInicial = dataInicial.replaceAll("/", "%2F");
  dataFinal = dataFinal.replaceAll("/", "%2F");

  return new Promise((resolve, reject) => {
    return api
      .get(
        endpoint +
          `/abertos-por-terceiros-encerrados-por-mim?${logins
            .map((login) => {
              return "logins=" + login;
            })
            .join("&")}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`
      )
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const obterNumerosTotaisDeAtendimentos = async (
  logins,
  dataInicial,
  dataFinal
) => {

  dataInicial = dataInicial.replaceAll("/", "%2F");
  dataFinal = dataFinal.replaceAll("/", "%2F");

  return new Promise((resolve, reject) => {
    return api
      .get(
        endpoint +
          `/totais-atendimentos?${logins
            .map((login) => {
              return "logins=" + login;
            })
            .join("&")}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`
      )
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default {
  obterTodosAtendimentosNaoEncerradosPrimeiroContato,
  obterTodosAtendimentosAbertosPorTerceirosEncerradosPorMim,
  obterNumerosTotaisDeAtendimentos,
};
